// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2keWN","alertIcon":"ConfirmModal_alertIcon__37sD1"};